
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { TicketInterface } from '@/services/QC-V2/ticket/interfaces';
import TicketDetails from '@/components/qa/ticket/TicketDetails.vue';
import TicketReplies from '@/components/qa/ticket/TicketReplies.vue';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';
import TicketPrivateNotes from '@/components/qa/ticket/TicketPrivateNotes.vue';
import TicketReview from '@/components/qa/ticket/TicketReview.vue';
import { ScoreTypeInterface } from '@/services/QC-V2/score-type/interfaces';
import { ScoreGradeInterface } from '@/services/QC-V2/score-grade/interfaces';
import { TagInterface } from '@/services/QC-V2/tag/interfaces';
import TicketReviewsDetails from '@/components/qa/ticket/TicketReviewsDetails.vue';
import TicketLogs from '@/components/qa/ticket/TicketLogs.vue';
import TicketTags from '@/components/qa/ticket/TicketTags.vue';
import TicketHBNotes from '@/components/qa/ticket/TicketHBNotes.vue';
import { UserBaseInfoInterface } from '@/services/Users/Interfaces';

interface ProfilesSelectInterface {
  id: string,
  name: string,
}

@Component({
  components: {
    TicketTags,
    TicketLogs,
    TicketHBNotes,
    TicketReviewsDetails,
    TicketReplies,
    TicketDetails,
    TicketPrivateNotes,
    TicketReview,
  },
  mixins: [
    Themeable,
  ],
  inject: [
    'commentRepositoryV2',
  ],
})
export default class ViewTicket extends Vue {
  private ticket!: TicketInterface;
  @Prop() private ticketProp!: TicketInterface;
  @Prop() private profilesMap!: ProfileMapInterface;
  @Prop() private profiles!: ProfilesSelectInterface[];
  @Prop() private users!: UserBaseInfoInterface[];
  @Prop() private scoreTypes!: ScoreTypeInterface[];
  @Prop() private scoreGrades!: ScoreGradeInterface[];
  @Prop() private tags!: TagInterface[];

  private get windowHeight(): number {
    return window.screen.height;
  }

  private created(): void {
    this.ticket = this.ticketProp;
  }

  private goBack(): void {
    this.$emit('close-ticket');
  }

  @Watch('ticketProp')
  private handleTicketUpdate(): void {
    this.$forceUpdate();
  }

  private handleTicketReview(ticket: TicketInterface): void {
    this.ticket = ticket;
    this.$emit('ticket-reviewed', ticket.id);
  }

  private canBeReviewed(): boolean {
    const isEscalated = !!this.ticket.escalation;
    const agentIds = this.users.map((user) => user.id);

    const allAgentsHasReviews = this.ticket.reviews
      .filter((review) => !review.deletedAt && !review.isDraft && agentIds.includes(review.reviewedId))
      .length === this.ticket.agents.length;

    if (!isEscalated && !allAgentsHasReviews) {
      return true;
    }

    return this.ticket.reviews.some((review) => review.isDraft);
  }
}
